import React from 'react';
import { useTranslation } from 'react-i18next';
import FeaturedSectionStats from '../../ui/FeaturedSectionStats';
import './IntroSectionFormationAF.css';

const IntroSectionFormationAF3: React.FC = () => {
  const { t } = useTranslation();

  // Data for FeaturedSectionStats specific to Azure Fundamentals Formation
  const formationStats = [
    {
      value: '18h',
      label: 'Formation certifiante',
      translationKey: 'formationAF.stats.duration',
      labelTranslationKey: 'formationAF.stats.durationLabel'
    },
    {
      value: '100%',
      label: 'Fondamentaux maîtrisés',
      translationKey: 'formationAF.stats.fundamentals',
      labelTranslationKey: 'formationAF.stats.fundamentalsLabel'
    },
    {
      value: 'AZ-900',
      label: 'Certification préparée',
      translationKey: 'formationAF.stats.certification',
      labelTranslationKey: 'formationAF.stats.certificationLabel'
    },
    {
      value: '∞',
      label: 'Évolution de carrière',
      translationKey: 'formationAF.stats.career',
      labelTranslationKey: 'formationAF.stats.careerLabel'
    }
  ];

  return (
    <div className="intro-section-home intro-section-formation-af">
      <div className="intro-row-1 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-8 tw-items-center tw-pt-[4em] max-[734px]:tw-pt-0">
        <div className="intro-text-1">
          <h2 style={{ fontSize: '62px', paddingBottom: '12px' }}>{t('formationAF.introSection.statsTitle', 'Notre engagement')}</h2>
        </div>
      </div>

      <FeaturedSectionStats
        title="Maîtrisez en 18h les fondamentaux Azure pour décrocher votre première certification."
        subtitle="Nous avons conçu un programme complet qui vous prépare efficacement à l'AZ-900 et vous donne les bases solides pour évoluer dans le cloud."
        titleTranslationKey="formationAF.stats.title"
        subtitleTranslationKey="formationAF.stats.subtitle"
        stats={formationStats}
        showChart={false}
      />
    </div>
  );
};

export default IntroSectionFormationAF3;
